(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ek-campaign-countdown')) return;

    function campaignTime(date, time, timezone) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '') || !/^\d{2}:\d{2}$/.test(time || '')) return NaN;
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute] = time.split(':').map(Number);
      const target = Date.UTC(year, month - 1, day, hour, minute);
      const check = new Date(target);
      if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day || hour > 23 || minute > 59) return NaN;
      try {
        const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        const wallTime = value => {
          const parts = Object.fromEntries(formatter.formatToParts(new Date(value)).map(part => [part.type, part.value]));
          return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
        };
        let candidate = target;
        for (let i = 0; i < 5; i++) {
          const difference = target - wallTime(candidate);
          if (difference === 0) return candidate;
          candidate += difference;
        }
      } catch (_) {}
      return NaN;
    }

    function codeEntries(cart) {
      if (Array.isArray(cart.discount_codes)) return cart.discount_codes;
      const applications = [...(cart.cart_level_discount_applications || [])];
      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) {
          if (allocation.discount_application) applications.push(allocation.discount_application);
        }
      }
      return applications.filter(application => application.type === 'discount_code').map(application => ({ code: application.title, applicable: true }));
    }

    class CampaignCountdown extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.button = this.querySelector('[data-activate]');
        this.status = this.querySelector('[data-status]');
        this.editor = this.dataset.designMode === 'true';
        this.end = campaignTime(this.dataset.endDate, this.dataset.endTime, this.dataset.timezone);
        this.start = this.dataset.startDate ? campaignTime(this.dataset.startDate, this.dataset.startTime, this.dataset.timezone) : -Infinity;
        this.configured = this.dataset.enabled === 'true' && this.dataset.code.trim() !== '' && !this.dataset.code.includes(',') && Number.isFinite(this.end) && !Number.isNaN(this.start) && this.start < this.end;
        this.key = ['ek-campaign', this.dataset.root, this.dataset.code.toUpperCase(), this.end].join(':');
        this.root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        this.refreshState = () => { if (!this.editor && !this.busy && this.active) this.sync(); };
        this.button.addEventListener('click', () => this.activate(), { signal: this.controller.signal });
        window.addEventListener('pageshow', this.refreshState, { signal: this.controller.signal });
        window.addEventListener('focus', this.refreshState, { signal: this.controller.signal });
        this.updateClock();
        this.timer = setInterval(() => this.updateClock(), 1000);
        if (!this.editor && this.active) this.sync();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
        this.controller = null;
        this.busy = false;
        this.syncing = false;
      }

      updateClock() {
        const now = Date.now();
        const previousActive = this.active;
        this.active = this.configured && now >= this.start && now < this.end;
        this.hidden = !this.active && !this.editor;
        const demoEnd = this.demoEnd || (this.demoEnd = now + 223029000);
        const deadline = Number.isFinite(this.end) ? this.end : demoEnd;
        const left = Math.max(0, Math.floor((deadline - now) / 1000));
        const values = [Math.floor(left / 86400), Math.floor(left / 3600) % 24, Math.floor(left / 60) % 60, left % 60];
        ['days', 'hours', 'minutes', 'seconds'].forEach((unit, index) => {
          this.querySelector('[data-' + unit + ']').textContent = String(values[index]).padStart(2, '0');
        });
        this.querySelector('.ek-campaign__timer').setAttribute('aria-label', this.dataset.endLabel + ' ' + new Intl.DateTimeFormat(document.documentElement.lang || 'sv', { dateStyle: 'long', timeStyle: 'short', timeZone: this.dataset.timezone }).format(new Date(deadline)));
        if (!this.active && !this.editor) this.button.disabled = true;
        if (previousActive === false && this.active && !this.editor) {
          this.showState('idle');
          this.sync();
        }
      }

      format(template) {
        return template.replace(/\{code\}/g, this.dataset.code);
      }

      selected(value) {
        try {
          if (value === true) sessionStorage.setItem(this.key, 'selected');
          if (value === false) sessionStorage.removeItem(this.key);
          return sessionStorage.getItem(this.key) === 'selected';
        } catch (_) { return value === true; }
      }

      showState(state, message = '') {
        this.button.disabled = state === 'confirmed' || state === 'pending' || state === 'loading' || (!this.active && !this.editor);
        this.button.setAttribute('aria-busy', String(state === 'loading'));
        const label = state === 'confirmed' ? this.dataset.confirmedLabel : state === 'pending' ? this.dataset.pendingLabel : state === 'loading' ? this.dataset.loadingLabel : this.dataset.buttonLabel;
        this.button.textContent = this.format(label);
        this.status.textContent = this.format(message);
      }

      renderCart(cart) {
        const entry = codeEntries(cart).find(discount => discount.code?.toUpperCase() === this.dataset.code.toUpperCase());
        if (entry?.applicable === true) {
          this.selected(true);
          this.showState('confirmed', this.dataset.confirmedMessage);
        } else if (cart.item_count === 0 && this.selected()) {
          this.showState('pending', this.dataset.pendingMessage);
        } else {
          const attempted = this.selected();
          this.selected(false);
          this.showState('idle', attempted ? this.dataset.ineligibleMessage : '');
        }
      }

      async request(path, options = {}) {
        const response = await fetch(this.root + path, { ...options, credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal, headers: { Accept: 'application/json', ...options.headers } });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }

      async sync() {
        if (this.syncing) return;
        this.syncing = true;
        try {
          const cart = await this.request('cart.js');
          if (this.isConnected && !this.busy) this.renderCart(cart);
        } catch (_) {
          if (this.isConnected && !this.busy) this.showState('idle');
        } finally { this.syncing = false; }
      }

      async activate() {
        if (this.busy) return;
        this.updateClock();
        if (this.editor) {
          this.showState('confirmed', this.dataset.confirmedMessage);
          return;
        }
        if (!this.active) return;
        this.busy = true;
        this.showState('loading');
        try {
          const before = await this.request('cart.js');
          const codes = codeEntries(before).map(discount => discount.code).filter(Boolean);
          if (!codes.some(code => code.toUpperCase() === this.dataset.code.toUpperCase())) codes.push(this.dataset.code);
          this.updateClock();
          if (!this.active) return;
          const cart = await this.request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
          const entry = codeEntries(cart).find(discount => discount.code?.toUpperCase() === this.dataset.code.toUpperCase());
          if (entry?.applicable === true) {
            this.selected(true);
            this.showState('confirmed', this.dataset.confirmedMessage);
            window.location.reload();
          } else if (cart.item_count === 0) {
            this.selected(true);
            const redirect = window.location.pathname + window.location.search + window.location.hash;
            window.location.assign('/discount/' + encodeURIComponent(this.dataset.code) + '?redirect=' + encodeURIComponent(redirect));
          } else {
            this.selected(false);
            this.showState('idle', this.dataset.ineligibleMessage);
          }
        } catch (_) {
          if (this.isConnected) this.showState('idle', this.dataset.errorMessage);
        } finally { this.busy = false; }
      }
    }
    customElements.define('ek-campaign-countdown', CampaignCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
